import * as sonbpIfconst from "../../sonbpIf/base/constants";
import * as idbEdit from "../../entity/idb/editInfo";
import * as es6promise from "es6-promise";
import { Logger } from "../../util/logger";
import { util } from "../..";
import { constDialogMessage, dialogUtil } from "../../util";
import { editStrage } from "../edit.tool";

import * as edconst from "../edit.const";
import { EditConst } from "../edit.const";
import { uploadPhoto } from "../edit.entity";
import { itemVenderProperty } from "../edit.sonbp_if";
import { UploadImageLogicClass } from "./edit.uploadImageLogic.base";
import * as effectMystampSDK from "../edit.effectMystampSDK";

/**
 * Myステッカー
 * 画像アップロード、画像配置の処理を提供するクラス
 */
export class MyStampLogicClass extends UploadImageLogicClass {

// #region ■定数

    /**
     * Myステッカー画像最大数
     * @override
     */
    protected readonly UPLOAD_IMAGE_NUM_MAX: number = 50;

    /**
     * 配置上限数
     * @override
     */
    protected readonly PUT_MAX: number = 50;

    /**
     * Myステッカーアップロード(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_UPLOADIMAGE: string = "Edit/UploadMyStamp";
    /**
     * Myステッカー画像サムネイル取得(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_GETTHUMBNAIL: string = "Edit/GetMyStampThumb";

    protected readonly VIEW_TITLE: string = EditConst.TITLE_MYSTAMP;
    protected readonly VIEW_MODE: string = edconst.EDIT_MODE_KIND.MYSTAMP;
    protected readonly VIEW_ITEM_TYPE: string = sonbpIfconst.ITYPE_MYSTAMP_IMG;

// #endregion

// #region ■プロパティ

    /**
     * アップロード画像最大数(Myステッカー用)
     * @implements
     */
    public UploadNumMax(): number {
        return this.UPLOAD_IMAGE_NUM_MAX;
    }

// #endregion

// #region ■イベント

    /**
     * ツールメニュー：Myステッカー押下メソッド
     * @summary 編集モードをスタンプにして画面表示を切り替える。
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * @implements
     */
    public btnClickStampMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {
        if (this._edctrl.editMode === edconst.EDIT_MODE_KIND.MYSTAMP) {
            return;
        }
        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(edconst.EDIT_MODE_KIND.MYSTAMP,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = edconst.EDIT_MODE_KIND.MYSTAMP;

                this.setShowFlgAllOFF();

                if (this._usePcDesign) {
                    // PC用
                    // パネルの表示制御
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.MyStampPanel = true;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveMyStampMenu = true;

                    // フェードインアウトの初期化
                    this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
                    this._vue.$data.MyStamp.fade.In = false;
                    this._vue.$data.MyStamp.fade.Out = false;

                    // オブジェクト操作パレットの制御
                    this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.MYSTAMP, null);

                    // 選択アイテムの指定
                    this.sonbpIfController.getMyStampList(
                        (list: itemVenderProperty[]) => {
                            if (0 < list.length) {
                                this._vue.$data.Show.OparatePalletCover = false;

                                const idx = selectedItemVp?.idx ?? list[0].idx;
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_MYSTAMP_IMG, idx,
                                    () => {
                                        Logger.debug("選択アイテムの指定 成功");
                                    },
                                    () => {
                                        Logger.error("選択アイテムの指定 失敗");
                                        this._vue.$data.Show.OparatePalletCover = true;
                                    });
                            }
                            else {
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                        }
                    );

                } else {
                    // SP用

                    // パネルの表示制御
                    this._vue.$data.Show.EditArea = true;
                    this._vue.$data.Show.FooterMenu = true;

                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    this.sonbpIfController.getMyStampList((list: itemVenderProperty[]) => {
                        // 作成済みのMyステッカーが存在するか判定
                        if (0 < list.length) {
                            // 存在する場合、Myステッカーの位置調整表示
                            this._vue.$data.Header.Title = EditConst.TITLE_MYSTAMP;
                            this._vue.$data.Show.ReturnHomeExBtn = true;
                            this._vue.$data.Show.CommitNextHomeBtn = true;

                            this._vue.$data.Stamp.DelBtnEnable = false;
                            this._vue.$data.EnableUploadListTrashOK = false;

                            // オブジェクト操作パレットの表示制御
                            this._vue.$data.Show.OparatePallet = true;
                            this._edctrl.setModeOparatePallet(edconst.EDIT_MODE_KIND.MYSTAMP, null);

                            // タッチイベント制御(無効)
                            this._edctrl.touchEventChange(false);

                            this._vue.$data.Show.OparatePalletCover = false;

                            // 選択アイテムの指定
                            const idx = selectedItemVp?.idx ?? list[0].idx;
                            this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_MYSTAMP_IMG, idx,
                                () => {
                                    Logger.debug("選択アイテムの指定 成功");
                                    this._vue.$data.Stamp.DelBtnEnable = true;
                                },
                                () => {
                                    Logger.error("選択アイテムの指定 失敗");
                                    this._vue.$data.Show.OparatePalletCover = true;
                                });
                        }
                        else {
                            // 存在しない場合、スタンプの編集表示
                            this.setStampEditMode();
                        }
                    });
                }
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
     * Myステッカーファイル選択押下時のダイアログ表示
     */
    public async btnClickUploadMyStamp(event: any) {
        // 「次回は表示しない」がチェックされたらダイアログ表示しない。
        if (this._vue.$data.ConfirmMyStampCheckbox) {
            $("#myStampInput").click();
        } else {
            this._vue.$data.ConfirmMyStampCheckbox = await dialogUtil.showMyStampHowToDlg(this._usePcDesign, () => { $("#myStampInput").click(); }, () => { });
        }
    }

    /**
     * 切抜き編集画像選択モードでの画像押下メソッド(PC用)
     */
    public async imgClickUploadImageForMystampEditPc(event: JQueryEventObject, fileId: string): es6promise.Promise<void> {
        try {
            await this.btnClickUploadMyStampEdit(event, fileId);
        } finally {
            //処理後は常にモードを元に戻す
            this.btnClickUploadListMystampEditCancelPc(event);
        }
    }

    /**
     * 切抜き編集ボタン押下メソッド(SP用)
     */
    public btnClickMyStampEditSp(event: JQueryEventObject): void {

        let fileId: string;

        // SPなら選択画像取得
        if (!this._usePcDesign) {
            const selPhoto: uploadPhoto = util.relic.listFind(this._uploadImageList, (photo: uploadPhoto) => {
                return photo.selected === EditConst.IMG_SELECTED;
            }, true);
            if (!selPhoto) {
                console?.debug("画像が選択されていません");
                return;
            }
            fileId = selPhoto.fileId;
        }

        this.btnClickUploadMyStampEdit(event, fileId);
    }

    /**
     * Myステッカーファイルの切抜き編集開始
     */
    private async btnClickUploadMyStampEdit(event: JQueryEventObject, fileId: string): es6promise.Promise<void> {

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // アップロードファイルの最大数チェック
        if (this.UploadNumMax() <= this.NotEmptyUploadNum) {
            // メッセージ表示
            util.dialogUtil.createErrorDialog(util.constDialogMessage.ERROR_IMAGE_UPLOAD_OVER_MAX_TEXT, () => {
                dialogUtil.closeErrorDialog();
                // ローディングダイアログ終了
                util.dialogUtil.closeLoading();
            }, dialogUtil.DialogType.Warning);
            return;
        }

        //指定スタンプIDでテンポラリ準備
        const param = {
            token: this._authToken,
            fileId: fileId
        }

        var that = this;
        await util.ajax.post("Edit/EditMystampInitTemp", JSON.stringify(param)).then((resData: any) => {

            //切抜き編集画面への連携開始
            that.editMystampStart();
        }).catch((e: Error) => {

            console?.error("Edit/EditMystampInitTemp NG.", e);
            util.dialogUtil.closeLoading();
        });
    }

    /**
     * Myステッカーの切抜き編集画面の連携呼出し
     */
    private editMystampStart() {
        console?.log("editMystamp call start.")

        if (this._usePcDesign) {
            // 2重スクロール抑止
            $('body').css({ "position": "fixed" });
        }
        //IFrame準備
        if (!($("#editMystampIframePanel").length)) {
            let fgblock =
                '<div id="editMystampIframePanel" class="fontgenicIframePanel is-hidden" >\
<iframe id="editMystampIframe" class="fontgenicIframeArea" name="editMystampIframe" frameborder="0" allow="fullscreen" class="fontgenicIframeArea" >\
</iframe>\
</div>'
            $('body').append($(fgblock));
        }

        $("#editMystampIframePanel").removeClass("is-hidden");
        if (this._usePcDesign) this._vue.$data.Show.IsShowIframePanel = true;

        //切抜き編集画面呼出し
        let that = this;
        effectMystampSDK.editmystampSdkInit("editMystampIframe",
            (fileKey: string) => {
                //OK
                console?.log("editMystampIframe callback OK.")

                //編集終了の後処理
                that.editmystampCallbackAfter(fileKey).then((newFileKey) => {
                    that.imgClickUploadImage(null, newFileKey);
                    if (this._usePcDesign) {
                        // 選択状態をクリア
                        for (let i: number = 0; i < this._uploadImageList.length; i++) {
                            this._uploadImageList[i].selected = EditConst.IMG_NOSELECT;
                        }
                    }
                }).finally(() => {

                    $("#editMystampIframePanel").remove();
                    util.dialogUtil.closeLoading();
                    if (this._usePcDesign) {
                        $('body').css({ "position": "" });
                        this._vue.$data.Show.IsShowIframePanel = false;
                    }
                });
            },
            (message) => {
                //キャンセル
                console?.log("editMystampIframe callback Cancel.", message);

                $("#editMystampIframePanel").remove();
                util.dialogUtil.closeLoading();
                if (this._usePcDesign) {
                    $('body').css({ "position": "" });
                    this._vue.$data.Show.IsShowIframePanel = false;
                }
            }
        );

        let url = document.location.pathname + '/../EditMystamp';
        effectMystampSDK.editmystampSdkCreate(url);
    }

    /**
     * Myステッカーの切抜き編集の後処理
     */
    private editmystampCallbackAfter(fileId: string): es6promise.Promise<any> {

        return new es6promise.Promise((resolve, reject) => {

            const param = {
                token: this._authToken,
                fileId: fileId
            }

            var that = this;
            util.ajax.post("Edit/EditMystampAfterSave", JSON.stringify(param)).then((resData: any) => {

                return that.getThumbnail(resData.fileId, resData.width, resData.height, resData.fileObject)
            }).then((data) => {

                console?.log("後処理正常終了", data);
                resolve(data);
            }).catch((e: Error) => {
                console?.error("後処理失敗", e);
                reject();
            });
        });
    }

// #endregion

// #region ■内部関数

    /**
     * Myステッカー編集モードへ画面項目設定(SP用)
     * @summary アップロード画像一覧画面を表示する。
     * @implements
     */
    public setStampEditMode() {

        // パネルの表示制御
        this.setShowFlgAllOFF();
        this._vue.$data.Header.Title = EditConst.TITLE_IMAGELIST;
        this._vue.$data.Show.MyStampList = true;
        this._vue.$data.Show.ReturnMyStampHomeBtn = true;
        this._vue.$data.Show.NextHomeFromMyStampListBtn = true;
        this._vue.$data.Show.MyStampListTrashBtn = true;

        // 選択状態をクリア
        for (let i: number = 0; i < this._uploadImageList.length; i++) {
            this._uploadImageList[i].selected = EditConst.IMG_NOSELECT;
        }

        // 削除(＆次へ)ボタンの活性制御
        this._vue.$data.EnableUploadListTrashOK = false;
    }

    /**
     * Myステッカー削除依頼処理
     * @summary 一覧から選択画像を削除し、Canvasに配置済ならその配置も引きはがす。
     * @implements
     */
    public requestRemove(fileIds: string[]) {

        this.sonbpIfController.removeMyStampById(fileIds,
            () => {
                Logger.debug("Myステッカー削除依頼処理 正常終了");
                // 正常終了の場合
                this.afterRemove();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_DEL_MYSTAMP, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
     * Myステッカー削除後の処理
     * @summary 一覧の削除枠を詰めて空き枠を整理する。
     * @override
     */
    protected afterRemove() {

        super.afterRemove();

        // 残スタンプを確認
        this.sonbpIfController.getMyStampList((stampList: itemVenderProperty[]) => {
            if (stampList.length === 0) {
                // ０件の場合
                this._vue.$data.Stamp.DelBtnEnable = false;
                this._vue.$data.Show.OparatePalletCover = true;
            }
            else {
                // 上記以外の場合
                let leftStamp: boolean = true;
                this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_MYSTAMP_IMG, () => { }, () => { leftStamp = false }, () => { leftStamp = false });
                if (leftStamp) {
                    this._vue.$data.Stamp.DelBtnEnable = true;
                } else {
                    this._vue.$data.Stamp.DelBtnEnable = false;
                    this._vue.$data.Show.OparatePalletCover = true;
                }
            }
        });
    }

    /**
     * Myステッカー画像設定処理(本体) 
     * @summary 選択された画像をCanvasへ配置する（実際の処理）
     * @implements
     */
    public setImageBody(fileId: string, targetPhoto: uploadPhoto, nextFun: () => void) {
        Logger.debug("Myステッカー画像押下メソッド fileId[" + fileId + "]");

        let that = this;
        this.commonSetStampBody(fileId, targetPhoto, () => {
            if (nextFun)
                nextFun();
        });
    }

    /**
     * 有効なアップロードファイルであるかのチェック(Myステッカー用)
     * @summary ファイルのサイズ・MIMEチェックを行う。
     * @implements
     */
    public uploadFileValid(file: File): string {

        Logger.debug("アップロード前ファイルチェック type[" + file.type + "] size[" + file.size + "]");

        // MIMEタイプチェック
        if (typeof file === 'undefined' || typeof file.type === 'undefined') {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_FORMAT_CHECK;
        }
        if (file.type.length !== 0 &&
            file.type !== 'image/jpeg' &&
            file.type !== 'image/pjpeg' &&
            file.type !== 'image/png') {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_FORMAT_CHECK;
        }

        // サイズ(容量チェック)
        if ((this._edctrl.ScreenCtrl.photoUlFileSizeMax * 1024 * 1024) < file.size) {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_SIZE_CHECK;
        }

        return "";
    }

    /**
     * 一覧をidbへ保存
     * @summary アップロード一覧情報をidbへ保存する
     * @implements
     */
    public writeStorage(list: idbEdit.photo[]): boolean {

        return editStrage.writeStorageToMyStamp(list);
    }

    /**
     * スタンプ配置
     * @summary SonbpIfへスタンプ配置を依頼する。
     * @implements
     */
    public callSonbpIfSetStamp(idx: number, target: uploadPhoto, okFunc: () => void, errFunc: () => void): void {

        this.sonbpIfController.setMyStamp(idx, target, okFunc, errFunc);
    }

    /**
     * 画像押下メソッド
     * @summary PCのディスパッチのみ
     */
    public imgClickUploadImageForMystampSelectedPc(event: JQueryEventObject, fileId: string): void {

        if (!this._usePcDesign) {
            return;
        }

        if (!fileId) {
            Logger.debug("fileId is undefined");
            return;
        }

        Logger.debug("画像押下メソッド fileId[" + fileId + "]");

        // 対象画像の現状態を取得
        const selImage: uploadPhoto = util.relic.listFind(this._uploadImageList, (p: uploadPhoto) => {
            return p.fileId === fileId;
        });
        if (!selImage) {
            return;
        }
        const targetSelected: string = selImage.selected === EditConst.IMG_SELECTED ? EditConst.IMG_NOSELECT : EditConst.IMG_SELECTED;
        const otherSelected: string = EditConst.IMG_NOSELECT;

        for (let i: number = 0; i < this._uploadImageList.length; i++) {
            if (this._uploadImageList[i].fileId === fileId) {
                this._uploadImageList[i].selected = targetSelected;
                this._vue.$data.MystampFileIdSelected = fileId;
            }
            else {
                this._uploadImageList[i].selected = otherSelected;
            }
        }
    }
// #endregion

}
